import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'sn-sso-mobile-denied',
  templateUrl: './sso-mobile-denied.component.html',
  styleUrls: ['./sso-mobile-denied.component.scss'],
})
export class SsoMobileDeniedComponent implements OnInit {
  public url: any;

  constructor(private readonly _sanitizer: DomSanitizer) {}

  public ngOnInit(): void {
    this.url = this._sanitizer.bypassSecurityTrustResourceUrl(
      'intent://fususone.com/login?status=denied#Intent;scheme=https;end',
    );
  }
}
